export class UpdateIsEditModeStateError extends Error {

}
